module.exports = __webpack_public_path__ + "media/no_resp.cbbcdcfd.wav";